module.exports = __webpack_public_path__ + "static/media/p209sq.769eae05.jpeg";